const servicesNameList = {
  "text-to-image-generator": { name: "TextToImg" },
  "photo-into-painting": { name: "PhotoIntoPainting" },
  "erase-and-replace": { name: "Erase&Replace" },
  "interior-design-planner": { name: "InteriorRedesign" },
  "remove-video-bg": { name: "Bgremover" },
  "illustration-drawing": { name: "illustratorDrawing" },
};

export { servicesNameList }

